import { FC } from 'react'
import BaseModal from 'components/Modals/BaseModal'
import { Card } from 'ui'
import { getPositionName, getProjectName } from 'services/Utilities'

import { t } from 'translations'

const PunchCardCommentsModal: FC<{ arrivalComment: string; leaveComment: string; transfers: MData.Transfer[] }> = ({
  arrivalComment,
  leaveComment,
  transfers
}): JSX.Element => {
  const transferWithComments = transfers?.filter(transfer => !!transfer.comment)
  const getTransferName = (transfer: MData.Transfer) =>
    (transfer.toPosition && getPositionName(transfer.toPosition)) || (transfer.toProject && getProjectName(transfer.toProject))
  return (
    <BaseModal title="components.comments.COMMENTS_MODAL">
      {arrivalComment ? (
        <div className="mt-3">
          <b>{t('components.comments.PUNCHIN_COMMENT')}</b>
          <Card maxHeight="10rem" className="bg-light py-3 pl-3 my-3">
            {arrivalComment}
          </Card>
        </div>
      ) : null}
      {transferWithComments.length ? (
        <div className="mt-3">
          {transferWithComments.map((transfer, index) => (
            <div key={index}>
              <div className="ml-2">
                <b>{`${transfer.toProject ? t('manager.punch.TRANSFER_PROJECT') : t('manager.punch.TRANSFER_POSITION')}: ${getTransferName(transfer)}`}</b>
              </div>
              <Card maxHeight="10rem" className="bg-light py-3 pl-3 my-3">
                {transfer.comment}
              </Card>
            </div>
          ))}
        </div>
      ) : null}
      {leaveComment ? (
        <div className="mt-3">
          <b>{t('components.comments.PUNCHOUT_COMMENT')}</b>
          <Card maxHeight="10rem" className="bg-light py-3 pl-3 my-3">
            {leaveComment}
          </Card>
        </div>
      ) : null}
    </BaseModal>
  )
}

export default PunchCardCommentsModal
